enum Equipment {
  FullCommercialGym = 'FullCommercialGym',
  LimitedGym = 'LimitedGym',
  FullHomeGym = 'FullHomeGym',
  DumbellsOnly = 'DumbellsOnly',
  ResistanceBandsOnly = 'ResistanceBandsOnly',
  Bodyweight = 'Bodyweight',
}

const equipmentQuestion = {
  name: 'equipment',
  title: 'What’s your typical setup for working out?',
  description: 'We’ll use this information to personalize your workout plan.',
  type: 'radiogroup',
  choices: [
    {
      value: Equipment.FullCommercialGym,
      text: "<div class='icon-button'><div>Full Gym<br /><span class=\"small-text\">Fully equipped commercial gym</span></div></div>",
    },
    {
      value: Equipment.LimitedGym,
      text: "<div class='icon-button'><div>Limited Gym<br /><span class=\"small-text\">Small gym with limited equipment</span></div></div>",
    },
    {
      value: Equipment.FullHomeGym,
      text: "<div class='icon-button'><div>Home Gym<br /><span class=\"small-text\">Basic equipment (squat rack, barbell, dumbbells, bench, etc.)</span></div></div>",
    },
    {
      value: Equipment.DumbellsOnly,
      text: "<div class='icon-button'><div>Dumbbells Only<br /><span class=\"small-text\">Set of dumbbells and a bench</span></div></div>",
    },
    {
      value: Equipment.ResistanceBandsOnly,
      text: "<div class='icon-button'><div>Resistance Bands Only<br /><span class=\"small-text\">Workout anywhere with resistance bands</span></div></div>",
    },
    {
      value: Equipment.Bodyweight,
      text: "<div class='icon-button'><div>Bodyweight Only<br /><span class=\"small-text\">Workout anywhere with just your bodyweight</span></div></div>",
    },
  ],
  // showOtherItem: true,
  isRequired: true,
};

export {
  Equipment,
  equipmentQuestion,
}